import React from 'react';
import RcSlider, { SliderProps as RcSliderProps } from 'rc-slider';
import 'rc-slider/assets/index.css';

const Slider = (props: RcSliderProps) => {
  return (
    <div
      style={{
        paddingTop: 20,
        paddingBottom: 20,
        paddingLeft: 8,
        paddingRight: 8,
      }}
    >
      <RcSlider
        trackStyle={{ backgroundColor: '#102e8e', height: 6 }}
        dotStyle={{
          borderColor: '#102e8ea0',
          height: 10,
          width: 10,
          borderWidth: 3,
          top: -2,
        }}
        handleStyle={{
          borderColor: '#102e8e',
          height: 12,
          width: 12,
          top: 7,
        }}
        activeDotStyle={{ borderColor: '#102e8e' }}
        railStyle={{ height: 6 }}
        {...props}
      />
    </div>
  );
};

export default Slider;
